// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1o01s","error":"Textarea_error__3ujJe","readonly":"Textarea_readonly__rs9h2","disabled":"Textarea_disabled__2JtRu"};